export default __webpack_public_path__ + "static/media/banner3.12c4f859.jfif";